module.exports = __webpack_public_path__ + "static/media/rambu handsWEB.6a81361e.jpg";